<template>
  <div class="colloquim">
    <section-heading>WHY COLLOQUIUM?</section-heading>
    <div class="background--linear">
      <b-container>
        <b-row>
          <b-col cols="10" offset="1">
            <div class="colloquim__info">
              <p class="colloquim__para">
                Your Productivity is a Function of your Habits.
              </p>
              <p class="colloquim__para--light">
                Knowledge & Awareness makes no difference.
              </p>
              <p class="colloquim__para">
                No teacher, guru, coach, mentor, trainer, consultant or advisor
                ever came back and asked you where are you stuck, why are you
                not able to do what I taught you?
              </p>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="colloquim__solutions">
      <div class="colloquim__solution colloquim__imageBox">
        <img src="../../assets/image/about/solution.jpg" class="img-fluid colloquim__image"/>
        <div class="colloquim__imageText">
          <img src="../../assets/image/about/solution-text.png" />
        </div>
      </div>
      <div class="colloquim__solution colloquim__box">
        <div class="colloquim__textBox">
          <h5 class="colloquim__title">Colloquium</h5>
          <h5 class="colloquim__title colloquim__title--padding">
            The Gain Livinar is the Solution.
          </h5>
          <p class="colloquim__details">
            It is a Live implementation system that shows you how to live a
            super-productive life by Habit in just 90 days.
          </p>
        </div>
      </div>
    </div>
    <section-button>CLICK HERE TO ENROL FOR FREE demo</section-button>
  </div>
</template>
<script>
import Heading from "../Shared/Heading";
import Button from "../Shared/Button";
export default {
  components: {
    "section-heading": Heading,
    "section-button": Button,
  },
};
</script>
<style scoped>
.colloquim {
  margin-bottom: 24px;
}

.colloquim__info {
  text-align: center;
  padding: 49px 0 60px 0;
}

.colloquim__para {
  font-family: "Seravek-Medium";
  text-transform: uppercase;
  font-size: 30px;
  color: var(--primary-color);
  margin-bottom: 0;
}

.colloquim__para--light {
  font-family: "Seravek-Light";
  font-size: 32px;
  line-height: 33px;
  color: var(--text-color);
  margin: 29px 0 21px 0;
}

.colloquim__solutions {
  display: flex;
  margin: 30px 0;
}

.colloquim__solution {
  width: 50%;
}

.colloquim__box {
  background-color: var(--primary-color);
  text-align: center;
  padding: 68px 0;
}

.colloquim__textBox {
  width: 520px;
  margin: 0 auto;
}

.colloquim__title {
  font-family: "Seravek-Medium";
  font-size: 39px;
  text-transform: uppercase;
  margin-bottom: 0;
  color: var(--secondary-color);
}

.colloquim__title--padding {
  padding: 0 80px;
}

.colloquim__details {
  font-family: "Seravek";
  font-size: 39px;
  line-height: 64px;
  text-transform: none;
  margin-top: 36px;
  margin-bottom: 0;
  color: var(--secondary-color);
}

.colloquim__imageBox {
  position: relative;
}

.colloquim__image {
  width: 100%;
  height: 100%;
}
.colloquim__imageText {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* Mobiles (Portrait) */
@media (min-width: 320px) and (max-width: 480px) {
  .colloquim__info {
    padding: 30px 0;
  }

  .colloquim__para{
    font-size: 20px;
    line-height: 24px;
  }

  .colloquim__para--light{
    font-size: 22px;
    line-height: 26px;
    margin: 15px 0;
  }

  .colloquim__solutions{
    flex-direction: column;
  }
  
  .colloquim__solution,.colloquim__textBox,.colloquim__imageText img{
    width: 100%;
  }

  .colloquim__title--padding{
    padding: 0 10%;
  }

  .colloquim__title{
    font-size: 22px;
  }

  .colloquim__details{
    font-size: 22px;
    line-height: 26px;
    margin-top: 20px;
  }

  .colloquim__box{
    padding: 40px 0;
  }
}

/* Low Resolution Tablets, Mobiles (Landscape) */
@media (min-width: 481px) and (max-width: 767px) {
 
 .colloquim__imageText img{
    width: 100%;
  }

  .colloquim__textBox{
    width: 90%;
  }

  .colloquim__box{
    padding: 30px 0;
  }

  .colloquim__title{
    font-size: 20px;
  }

  .colloquim__title--padding{
    padding: 0 40px;
  } 

  .colloquim__details{
    font-size: 20px;
    line-height: 22px;
    margin-top: 20px;
    padding: 0 20px;
  }

  .colloquim__info{
    padding: 35px 0;
  }

  .colloquim__para{
    font-size: 21px;
    line-height: 24px;
  }

  .colloquim__para--light{
    font-size: 22px;
    line-height: 24px;
    margin: 15px 0;
  }
}
/* Tablets, Ipads (portrait) */
@media (min-width: 768px) and (max-width: 1024px) {
  .colloquim__imageText img{
    width: 100%;
  }

  .colloquim__textBox{
    width: 90%;
  }
   .colloquim__box{
    padding: 30px 0;
  }
  .colloquim__title--padding{
    padding: 0 50px;
  }
  .colloquim__details[data-v-360321f1] {
    font-size: 28px;
    line-height: 32px;
    margin-top: 30px;
  }
  .colloquim__title,.colloquim__para{
    font-size: 26px;
  }
  .colloquim__para--light{
    font-size: 28px;
    line-height: 30px;
    margin: 20px 0;
  }
}


</style>